<template>
  <div>

    <c회원선택 ref="selectCustAll" @select="selectCust" :memblist=selectCustList />

    <h5 class="pop_tit window-header"><!-- 타이틀바 -->
      {{ sitem.REPTYY }}년 수임사건 신고서 {{ isEditMode ? '수정' : '작성하기' }}
    </h5>
    <span class="pop_close d2" @click="$emit('close')"></span><!-- 닫기 -->
    <div class="popup_wrap">



      <!-- ------------------------------------------------------------------------------------------------------------------------------------ -->
      <!-- 폼 : 인정사항등 -->
      <!-- ------------------------------------------------------------------------------------------------------------------------------------ -->

      <!-- <h4 class="sub_title02">
        신고서 {{ isEditMode ? '수정' : '신규(추가)작성' }}
        <button v-if="isEditMode" @click="initData" class="btn black02 outline">취소(신규등록)하기</button>
      </h4> -->

      <!-- {{ sitem.기간여부 }} -->
      <table class="tbl01 view01">
        <tr>
          <th>귀속수임연도</th><td> {{ sitem.REPTYY }} 년</td>
        </tr><tr>
          <th>수임기간    </th><td> {{ sitem.REPTYY }}.01.01 ~ {{ sitem.REPTYY }}.12.31 </td>

<!--
            <template v-if="isEditMode"> {{ sitem.REPTYY }} 년 </template>  -- 수정모드일땐 년도선택 불가 --
            <select v-else v-model="sitem.REPTYY" @change="doChangeYear()">      -- 등록모드일땐 년도선택 가능 --
              <option v-for="item in reptyy_list" :value="item.REPTYY" :key="item.REPTYY">{{item.REPTYY}}년</option>
            </select>
            <template v-if="isEditMode">   -- 수정 --
              <template v-if="sitem.기간여부 == '기간내'"><br/>
                신고기간({{ sitem.EDITFR | moment('YY.MM.DD') }} ~ {{ sitem.EDITTO  | moment('YY.MM.DD')  }}) 내 수정입니다.
                마감일({{ sitem.EDITTO  | moment('YY.MM.DD(ddd)')  }})이 지나기 전에는 계속 수정 가능합니다.
              </template>
              <template v-else-if="sitem.기간여부 == '기간후'"><br/>
                마감일({{ sitem.EDITTO  | moment('YY.MM.DD(ddd)')  }})이 지나서 <span class="noedit">수정이 불가능합니다.</span>
              </template>
            </template>
            <template v-else-if="!isEditMode">  -- 등록 --
              <template v-if="sitem.기간여부 == '기간내'">
                신고기간({{ sitem.EDITFR | moment('YY.MM.DD') }} ~ {{ sitem.EDITTO  | moment('YY.MM.DD')  }}) 내 제출입니다.
                마감일({{ sitem.EDITTO  | moment('YY.MM.DD(ddd)')  }})이 지나기 전에는 제출후에도 수정 가능합니다.
              </template>
              <template v-else-if="sitem.기간여부 == '기간후'">
                마감({{ sitem.EDITTO  | moment('YY.MM.DD')  }}) 후 제출입니다.
                <span class="noedit"> 제출하시면 수정이 불가능합니다. 신중히 등록해주세요. </span>
              </template>
            </template>
-->
        </tr>
        <tr>
          <th>신고일</th> <td> {{ (mode == 'add' ? $moment().format('YYYY.MM.DD') : sitem.INCMGDT) | moment('YYYY.MM.DD.')  }} </td>
        </tr><tr>
          <th>신고인</th> <td> <template v-if="sitem.MEMBNM"> {{ sitem.MEMBNM }}({{ sitem.MEMBNO }})</template> </td>
        </tr>
        <tr>
          <th>사무실 선택</th>
          <td>
              <label v-for="item in officeKindList" :key="item.value" class="pr10" style="display: inline-block;">
                <!-- 이미 신고한 경우 disable -->
              <input
                type="radio"
                v-model="sitem.OFFICEKIND"
                :value="item.text"
                :id="item.value"
                class="sch_input"
                @input="onChangeOfficeKind"
                :disabled="!['D','J'].includes(sitem.membclsf) && _.findIndex(sitem.apply_list, { OFFICEKIND: item.value }) >= 0"
              /> {{ item.text }}</label>
              <template v-if="$store.state.session.user.type != 'master'">
                <label class="pr10" style="display: inline-block;"><input type="radio" v-model="sitem.OFFICEKIND" value="etc">직접입력</label>
                <input v-if="sitem.OFFICEKIND == 'etc'" type="text" v-model="sitem.OFFICEKIND_ETC" ref="OFFICEKIND_ETC" class="w150">
              </template>
          </td>
        </tr>
        <template v-if="$store.state.session.user.type != 'master'">
          <tr>
            <th>사무실명</th>
            <td ><input type="text" class="w100p" v-model="sitem.OFFICENM" placeholder="주사무소가 타회일 경우 입력"></td>
          </tr>
        </template>
        <template v-else-if="sitem.OFFICEKIND == '분사무소'">
          <tr>
            <th>분사무소 이름</th>
            <td >
              <!-- {{ sitem.OFFICENM }} &nbsp; -->
              <input type="text" v-model="sitem.OFFICEKIND_ETC" ref="OFFICEKIND_ETC2"  placeholder="분사무소 이름 입력" class="w200">
            </td>
          </tr>
        </template>
        <tr v-show="$store.state.session.user.type != 'master' || sitem.OFFICEKIND == '분사무소'">
          <th>{{ sitem.OFFICEKIND == '분사무소' ? '분사무소 변호사' : '공동신고인' }}</th>
          <td>
                <input type="text" v-model="sitem.search_membnm" @keydown.enter="callSelectCust()" class="w40p" />
                <i-btn @click="callSelectCust()" class="btn xs black01 ">회원선택</i-btn>

            <div class="damdang_wrap" style="max-height: 170px; overflow-y: auto">
              <!-- div 팝업 :: 담당 변호사 검색 결과-->
              <table class="tbl01 list01">
                <tr>
                  <th width="60px" style="width: 60px !important;">등록번호</th>
                  <th width="150">회원명</th>
                  <th width="50">생년월일</th>
                  <th width="114">타회소속 회원여부</th>
                  <th width="52">삭제</th>
                </tr>
                <tr v-for="(item, i) in selectCustList" :key="i">
                  <td>{{ item.membno }}</td>
                  <td>{{ item.membnm }}</td>
                  <td>{{ item.birthday }}</td>
                  <td>{{ item.guestyn }}</td>
                  <td>
                    <span
                      v-if="showChargerDeleteBtn(item)"
                      @click="delCust(item)"
                      class="btn xs org01 outline">삭제</span></td>
                </tr>
              </table>
              </div><!--//damdang_wrap -->
          </td>
        </tr>
      </table>

      <!-- ------------------------------------------------------------------------------------------------------------------------------------ -->
      <!-- 폼 : 건수 / 금액  -->
      <!-- ------------------------------------------------------------------------------------------------------------------------------------ -->

      <h4 class="sub_title02 mt30"><small>{{ sitem.REPTYY }}년도 수임사건의 건수 및 수임액</small></h4>

      <div class="scroll_wrap "> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
        <table class="tbl01 vialist mt5 input_w100p">
          <colgroup>
            <col width="120"/>
            <col width="60"/><col width="100"/>
            <col width="60"/><col width="100"/>
            <col width="60"/><col width="100"/>
          </colgroup>
          <tr>
            <th width="80">사건구분</th>
            <th class="line_l" colspan="2">① 본안사건<br/> <font class="red01">(일반,소액,고액)</font></th>
            <th colspan="2" class="line_l c9">② 신청사건</th>
            <th colspan="2" class="line_l c9">③ 등기사건</th>
            <th class="line_l c9">비고</th>
            <th colspan="2" class="line_l c9">합계(①+②+③) <font class="red01">자동계산</font></th>
          </tr>
          <tr>
            <th>항목</th>
            <th class="line_l">건수</th>
            <th>수임액</th>
            <th class="line_l c9">건수</th>
            <th>수임액</th>
            <th class="line_l c9">건수</th>
            <th>수임액</th>
            <th class="line_l c9">비고</th>
            <th class="line_l c9 ">건수</th>
            <th >수임액</th>
          </tr>
          <tr style="display: none">
            <th v-tooltip="`${ sitem.REPTYY }년도의 수임건수를 DB조회한 결과입니다. 단순 참고용입니다.`">DB조회(참고용)</th>
            <td class="line_l">{{ sitem.CASE1_CNT | comma }}</td>
            <td class=" c9"   >{{ sitem.CASE1_AMT | comma }}</td>
            <td class="line_l c9">{{ sitem.CASE2_CNT | comma }}</td>
            <td class=" c9">{{ sitem.CASE2_AMT | comma }}</td>
            <td class="line_l c9">{{ sitem.CASE3_CNT | comma }}</td>
            <td class=" c9">{{ sitem.CASE3_AMT | comma }}</td>
            <td class="line_l c9"></td>
            <td class="line_l c9  ">{{ totOrgCnt | comma}} </td>
            <td >{{ totOrgAmt | comma}} </td>
          </tr>
          <tr>
            <th v-tooltip="`${ sitem.REPTYY }년도에 해당 사무실형태(${ sitem.OFFICEKIND })로 실제로 수임한 내용을 입력해주세요.`">입력(신고용)</th>
            <td class="line_l"   ><i-input-money type="text" v-model="sitem.BASISNUMOFCASE"   class="cnt" :disabled="isReadOnly || suimYN" :maxlength="5" /></td>
            <td                  ><i-input-money type="text" v-model="sitem.BASISCNTCHARGAMT" class="cnt" :disabled="isReadOnly || suimYN" :maxlength="13"/></td>
            <td class="line_l c9"><i-input-money type="text" v-model="sitem.APLCNUMOFCASE"    class="cnt" :disabled="isReadOnly || suimYN" :maxlength="5" /></td>
            <td                  ><i-input-money type="text" v-model="sitem.APLCCNTCHARGAMT"  class="cnt" :disabled="isReadOnly || suimYN" :maxlength="13"/></td>
            <td class="line_l c9"><i-input-money type="text" v-model="sitem.REGINUMOFCASE"    class="cnt" :disabled="isReadOnly || suimYN" :maxlength="5" /></td>
            <td                  ><i-input-money type="text" v-model="sitem.REGICNTCHARGAMT"  class="cnt" :disabled="isReadOnly || suimYN" :maxlength="13"/></td>
            <td class="line_l c9"><input type="text" v-model="sitem.REMK"                               :disabled="isReadOnly || suimYN"/></td>
            <td class="line_l c9">{{ totCnt | comma }}</td>
            <td >{{ totAmt | comma }}</td>
          </tr>
      </table>
    </div> <!--// scroll_wrap -->

    <div v-if="sitem.REMK && sitem.REMK.length > 10" style="margin-top: 10px; margin-left: 10px; color: gray;">
      비고내용 :
      <div style="margin-left: 70px; margin-top: -15px;">
        {{ sitem.REMK }}
      </div>
    </div>
    <div class="red01 mt10" style="line-height: 20px;">
      ※ 건수는 '수임일' 기준으로 입력(수임사건 내역 조회 > 수임사건 건수 조회 확인)<br/>
      ※ 수임액은 수임연도의 기간 중 수임한 사건의 총 수임액(부가세 포함)을 기재<br/>
      <!-- <span class="txt_info ft16" id="id_rel" @click="comment_show"> -->
      <span id="id_rel" @click="comment_show">
        ※ 귀속 수임사건의 건수 및 수임액 신고서 <b>작성방법</b><em class="icon_info">i</em>
      </span>
    </div>
      <div v-if="isReadOnly" class="btn_group">
        <div class="right" style="color: red; font-size: 17px; font-weight: bold;">
          마감일({{ sitem.EDITTO  | moment('YY.MM.DD(ddd)')  }})이 지나서 수정이 불가능합니다.
          <button @click="printItem" class="btn black01 outline">인쇄</button>
          <button @click="$emit('close')" class="btn black01">닫기</button>
        </div>
      </div>
      <div v-else class="btn_group">
        <div class="right">

          <template v-if="!isEditMode && sitem.기간여부 == '기간후'">
            마감({{ sitem.EDITTO  | moment('YY.MM.DD')  }}) 후 제출입니다.
            <span class="noedit"> 제출하시면 수정이 불가능합니다. 신중히 등록해주세요. </span>
          </template>

          <button @click="printItem" class="btn black01 outline">인쇄</button>
          <button v-if="isEditMode" @click="removeItem" class="btn black01">삭제하기</button>
          <button v-if="!isEditMode" @click="setMusuim" class="btn black01 outline">무수임 신고</button>
          <button v-if="isEditMode" @click="saveItem" class="btn black01">수정하기</button>
          <button v-if="!isEditMode" @click="saveItem" class="btn black01">제출하기</button>
          <button @click="$emit('close')" class="btn black01">닫기</button>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
let ui
import Printd from 'printd'
export default {
  components: {
    "c회원선택"     : require('@/components/c회원선택.vue').default,
  },
  props : {
    item: { type: Object, required: true, },
    mode: { type: String, required: true, },
    parentReload: { type: Function, required: true, },
    comment_show: { type: Function, required: true, },
  },
  data() {
    return {
    sitem: {},
      list: {}, // 신고현황 리스트
      reptyy_list: [], // 귀속수임년도 select box용 [ REPTYY, ]
      selectCustList : [], // 담당변호사 목록
      officeKindList : [], // 사무실 형태
      suimYN : false, // 무수임신고 여부
    }
  },
  computed: {
    isEditMode() { return !!this.sitem.REPSEQ }, // 수정모드 여부
    isReadOnly() { return !!this.sitem.REPSEQ && this.sitem.기간여부 == '기간후' }, // readOnly 여부
    totOrgCnt() { return T.toInt(this.sitem.CASE1_CNT)        + T.toInt(this.sitem.CASE2_CNT)       + T.toInt(this.sitem.CASE3_CNT)      }, // DB 조회 합계 - 건수
    totOrgAmt() { return T.toInt(this.sitem.CASE1_AMT)        + T.toInt(this.sitem.CASE2_AMT)       + T.toInt(this.sitem.CASE3_AMT)      }, // DB 조회 합계 - 금액
    totCnt()    { return T.toInt(this.sitem.BASISNUMOFCASE)   + T.toInt(this.sitem.APLCNUMOFCASE)   + T.toInt(this.sitem.REGINUMOFCASE)  }, // 사용자 입력 - 건수 입력 합계
    totAmt()    { return T.toInt(this.sitem.BASISCNTCHARGAMT) + T.toInt(this.sitem.APLCCNTCHARGAMT) + T.toInt(this.sitem.REGICNTCHARGAMT)}, // 사용자 입력 - 금액 입력 합계
  },
  created() {
    ui = this.$ui;
    console.log("mode =", this.mode, ", item =", this.item)
  },
  mounted() {
    // 공통코드 로드
    ui.codeLoad("OFFICEKIND", code => {
      this.code = code
      if (this.$store.state.session.user.type == 'master') {
        if (this.$store.state.session.user.membclsf == 'J' || this.$store.state.session.user.membclsf == 'D') {
          this.officeKindList = this.code.OFFICEKIND.filter(e => e.value == 'J' || e.value == 'D' || e.value == 'S' ) // 법인은 법무법인만
        } else {
          this.officeKindList = this.code.OFFICEKIND.filter(e => e.value == 'B' || e.value == 'S') // 법인은 법무법인만
        }
      } else {
        this.officeKindList = this.code.OFFICEKIND.filter(e => e.value != 'S') // 개인/소속일땐 분사무소 제외
      }
      if (this.mode == 'edit') {
        this.reportLoad(this.item)
      } else {
        this.getData()
      }
    })

    // 인쇄
    this.d = new Printd()
    const { contentWindow } = this.d.getIFrame()

    contentWindow.addEventListener(
      'beforeprint', () => console.log('before print event!')
    )
    contentWindow.addEventListener(
      'afterprint', () => console.log('after print event!')
    )

    ui.httpGet("/return_req/reptyy_list", {}, ret => this.reptyy_list = ret.data.list )
  },
  methods: {
    // 회원 검색 호출
    callSelectCust() {
      console.log("this.item.REPTYY = ", this.item.REPTYY);

      if (this.sitem.OFFICEKIND == '분사무소') {
        // this.$refs.selectCustMy.open('P',this.sitem.search_membnm, '', 'Y', 'N', 'reportcay')
        // this.$refs.selectCust.open('B', this.sitem.search_membnm, this.sitem.selldt, this.sitem.cntchargdt)
        this.$refs.selectCustAll.open('P', this.sitem.search_membnm, '', 'Y', 'N', 'reportcaymy', this.item.REPTYY)
      } else { // 분사무소가 아닐땐 전체 회원 검색
        this.$refs.selectCustAll.open('P', this.sitem.search_membnm, '', 'Y', 'N', 'reportcay', this.item.REPTYY)
      }
    },

    getData() { // 기본 데이터 조회

      // 1. 상세조회 ( 완료후 2 건수조회)
      ui.httpGet("/return_req/get_sitem", _.pick(this.item, ['REPTYY']), ret => { // 상세조회
        this.sitem = ret.data.sitem

        // 법인이 로그인하지 않고 개인이 로그인한 경우 신고할 변호사 목록에 자동으로 본인 추가
        if (this.$store.state.session.user.membclsf == 'P') {
          this.selectCustList = [{
            membclsf : this.sitem.MEMBCLSF,
            membno   : this.sitem.MEMBNO,
            membnm   : this.sitem.MEMBNM,
            birthday : this.sitem.BIRTHDAY,
            guestyn  : 'N',
          }]
        }

        // 2. 건수 조회 -- sitem.selectCustList 을 사용하므로 이곳에 있어야 함
        this.getCaseCount() // 건수 db 조회
      })

    },
    reportLoad(item) { // 저장된 데이터 보기
      this.$ui.httpGet("/return_req/view", _.pick(item, ['REPTYY', 'REPSEQ']),
        ret => {
          this.sitem          = ret.data.sitem
          this.selectCustList = ret.data.cntchargmembs
          this.getCaseCount()

          // [사무실 형태] 코드에 해당하는 값이 없으면 [직접입력]으로 보임
          // let check_office = this.code.OFFICEKIND.filter(e => e.text == this.sitem.OFFICEKIND)

          // if (check_office.length == 0) { // OFFICEKIND 값이 [사무실 형태] 코드에 일치 하는 것이 없다
            // this.sitem.OFFICEKIND_ETC = this.sitem.OFFICEKIND
            // this.sitem.OFFICEKIND = 'etc'
          // }
        },
      )
    },
    getCaseCount() { // 수임건수만 조회 ( 속도 느려서 따로 조회)
      this.sitem.s_membnos = this.selectCustList.map(i=>i.membno)
      this.sitem.CASE1_CNT = this.sitem.CASE2_CNT = this.sitem.CASE3_CNT =
      this.sitem.CASE1_AMT = this.sitem.CASE2_AMT = this.sitem.CASE3_AMT = "(조회중)"
      ui.httpPost("/return_req/case_cnts", _.pick(this.sitem, ['REPTYY', 's_membnos']),
        ret => {
          this.sitem = {...this.sitem, ...ret.data.case_cnts}
          // console.log();
          // T.putAttrs(this.sitem, ret.data.case_cnts, ['CASE1_CNT', 'CASE2_CNT', 'CASE3_CNT'])
        })
    },
    doChangeYear() { // 년도를 변경한 경우
      // sitem 조회하여 기관관련 정보 설정 ( 속도 : 빠름 )
      ui.httpGet("/return_req/get_sitem", _.pick(this.sitem, ['REPTYY']),
        ret => T.putAttrs(this.sitem, ret.data.sitem, ['EDITFR', 'EDITTO', '기간여부']) )
      this.getCaseCount() // 건수 db 조회 (속도 느려서 따로 조회)
    },
    // -------------------------------------------------------------------------------------------------------------------
    // 담당변호사 관련
    // -------------------------------------------------------------------------------------------------------------------
    showChargerDeleteBtn(item) { // 담당변호사 삭제 버튼
      const 내꺼여부 = this.$store.state.session.user.membno == item.membno && this.$store.state.session.user.membclsf == 'P'
      // console.log("내꺼여부 = 2", item);
      // console.log("내꺼여부 = 2", item.membno);
      return 내꺼여부 ? false : true
    },
    selectCust(item) { // 담당변호사 한명 추가
      if (this.selectCustList.filter(e => e.membclsf == item.membclsf && e.membno == item.membno).length > 0) {
        return ui.notify("이미 추가되어 있습니다.")
      }

      item.membseq = this.selectCustList.length + 1
      item.guestyn = item.guestyn || 'N' // 타회소속 직접 입력 여부

      this.selectCustList.push(item)

      this.getCaseCount() // 건수 db조회 재실행
    },
    delCust(item) { // 담당변호사 한명 제거
      //this.selectCustList = this.selectCustList.filter(e => e.membseq != item.membseq)
      this.selectCustList = this.selectCustList.filter(e => e.membno != item.membno)

      this.getCaseCount() // 건수 db조회 재실행
    },
    // -------------------------------------------------------------------------------------------------------------------
    // 담당변호사 END
    // -------------------------------------------------------------------------------------------------------------------
    setMusuim(){ // [무수임 신고] - 필수체크, 0 셋팅, 저장하기,
      if (T.isEmpty(this.sitem.OFFICEKIND)) {
        return ui.alert("사무실 형태를 선택해 주세요.")
      }

      if (this.sitem.OFFICEKIND == 'etc' && _.isEmpty(this.sitem.OFFICEKIND_ETC)) {
        return ui.alert("사무실형태를 기타로 선택하신경우 \n기타내용을 입력하셔야 합니다.")
          .then(()=>this.$refs.OFFICEKIND_ETC.focus())
      }

      if (this.sitem.OFFICEKIND == '분사무소' && _.isEmpty(this.sitem.OFFICEKIND_ETC)) {
        return ui.alert("사무실형태를 분사무소 선택하신경우 \n분사무소 이름을 입력하셔야 합니다.")
          .then(()=>this.$refs.OFFICEKIND_ETC2.focus())
      }

      this.suimYN = true

      // 모든 수임건수와 수임액을 0으로 셋팅
      this.sitem.BASISNUMOFCASE   =  0
      this.sitem.BASISCNTCHARGAMT =  0
      this.sitem.APLCNUMOFCASE    =  0
      this.sitem.APLCCNTCHARGAMT  =  0
      this.sitem.REGINUMOFCASE    =  0
      this.sitem.REGICNTCHARGAMT  =  0
      this.sitem.TOTNUMOFCASE     =  0
      this.sitem.TOTCNTCHARGAMT   =  0
      this.sitem.REMK   =  ''

      ui.confirm('무수임 신고 시, 수임건수 및 수임액은 0으로 자동설정됩니다. <br/> 제출하시겠습니까?', "무수임 신고 확인")
        .then(r => {
          if (r) {
            this.itemUpdate()
          } else {
            this.suimYN = false
          }
        })

    },
    saveItem() { // 필수체크하고 저장하기 호출
      if (T.isEmpty(this.sitem.OFFICEKIND)) {
        return ui.alert("사무실 형태를 선택해 주세요.")
      }

      if (this.sitem.OFFICEKIND == 'etc' && _.isEmpty(this.sitem.OFFICEKIND_ETC)) {
        return ui.alert("사무실형태를 기타로 선택하신경우 \n기타내용을 입력하셔야 합니다.")
          .then(v=>this.$refs.OFFICEKIND_ETC.focus())
      }

      if (this.sitem.OFFICEKIND == '분사무소' && _.isEmpty(this.sitem.OFFICEKIND_ETC)) {
        return ui.alert("사무실형태를 분사무소 선택하신경우 \n분사무소 이름을 입력하셔야 합니다.")
          .then(()=>this.$refs.OFFICEKIND_ETC2.focus())
      }

      // 20.01.02 건수 입력하지 않고, 금액만 입력해도 저장가능하도록 요청함.
      // if (this.totCnt == 0) {
      //   return ui.alert("수임사건을 1건이상 입력해 주세요.")
      // }

      ui.confirm('신고하시겠습니까 ?', "확인")
        .then(r => r && this.itemUpdate())
    },
    itemUpdate() { // 서버에 저장하기

      // 건수 및 금액 입력안하면 0으로 : 없는 값도 0으로 다 채움
      this.sitem.BASISNUMOFCASE   = this.sitem.BASISNUMOFCASE    || 0
      this.sitem.BASISCNTCHARGAMT = this.sitem.BASISCNTCHARGAMT  || 0
	    this.sitem.APLCNUMOFCASE    = this.sitem.APLCNUMOFCASE     || 0
	    this.sitem.APLCCNTCHARGAMT  = this.sitem.APLCCNTCHARGAMT   || 0
	    this.sitem.REGINUMOFCASE    = this.sitem.REGINUMOFCASE     || 0
	    this.sitem.REGICNTCHARGAMT  = this.sitem.REGICNTCHARGAMT   || 0
	    this.sitem.TOTNUMOFCASE     = this.sitem.TOTNUMOFCASE      || 0
      this.sitem.TOTCNTCHARGAMT   = this.sitem.TOTCNTCHARGAMT    || 0

      // 사무실 형태 [직접입력] 선택 시 : 입력 받은 값을 OFFICEKIND로 설정
      // if (this.sitem.OFFICEKIND == 'etc' || this.sitem.OFFICEKIND == '분사무소') {
      //   this.sitem.OFFICEKIND = this.sitem.OFFICEKIND_ETC
      // }

      ui.httpPost(this.sitem.REPSEQ ? '/return_req/req_update' : '/return_req/req_insert',
        {
          ...this.sitem
          , membs : this.selectCustList
          , TOTNUMOFCASE   : this.totCnt
          , TOTCNTCHARGAMT : this.totAmt
        },
        ret => {
          const {status, msg} = _.get(ret, "data", {})
          if (status == 'ok') {
            return ui.alert(msg)
              .then(v=>{
                this.parentReload()
                this.$emit('close')
              })
          } else {
            return ui.alert_error(msg)
          }
        },
      )
    },
    removeItem() { // 삭제하기
      ui.confirm('정말로 삭제하시겠습니까 ?', "삭제확인")
        .then(r => r && ui.httpGet("/return_req/remove",
          _.pick(this.sitem, ['REPTYY', 'REPSEQ']),
          ret => {
            if (_.get(ret, "data.status") == "ok") {
              return ui.alert("삭제되었습니다.")
                .then(v=>{
                  this.parentReload()
                  this.$emit('close')
                })
            } else {
              ui.alert_error("삭제중 오류가 발생했습니다.")
            }
          }
        )
      )
    },
    onChangeOfficeKind(e) {
      if(e.target.value=='분사무소'){
        setTimeout(v=>{this.$refs.OFFICEKIND_ETC2.focus()},100)
      }
    },
    printItem() { // 인쇄

      this.d.print( this.$el, [`
        .tbl01 { border-top:2px solid #666; width:100%;border-collapse: collapse; font-size:13px; }
        .tbl01.line { border:2px solid #aaa}

        .tbl01 th { border-bottom:1px solid #ddd; border-left:1px solid #ddd; padding:7px 12px; background-color: #f3f3f3; line-height: 1.8; vertical-align: top;}
        .tbl01 td { padding:7px 2px; border-bottom:1px solid #ddd;border-left:1px solid #eee;line-height: 1.6; box-sizing: border-box; text-align: left;}

        /* 하단 건수 및 수임액 표 */
        .tbl01 th { min-width:80px; }
        .tbl01.vialist td { text-align: center; }
        .tbl01 th.line_l, .tbl01 td.line_l { border-left: 1px solid rgb(153, 153, 153); min-width:40px; }
        .tbl01 th:last-child, .tbl01 td:last-child { border-right:1px solid #eee;}

        /* 공동신고인 */
        .damdang_wrap { margin-top:10px;}
        .damdang_wrap .tbl01 td, .damdang_wrap .tbl01 td, .damdang_wrap .tbl01 th:first-child { text-align:center; padding: 7px 0 !important ; }

        .icon_info, #id_rel, .btn, .scroll_txt, .btn_group { display:none;}
        input[type="text"] { border:none; }
        input[type="text"].cnt { text-align: center; border:none; max-width:110px;}
        .tbl01 td.line_l input[type="text"].cnt { text-align: center; border:none; max-width:40px; }
    `])
    },
  },
}
</script>



<style scoped>

  input.cnt { text-align: center;  cursor: default; }

  .noedit { font-weight: bold; color: red; }
  #id_rel .toggleInfo { margin:-357px auto;width:790px; height:762px; }
  #id_rel .toggleInfo .cont li { font-weight: bold; font-size:12px; margin-top:8px;}
  #id_rel .toggleInfo .cont p{ margin-top:5px; font-weight: normal}
  #id_rel { text-decoration: underline; }
  #id_rel:hover .toggleInfo{ display: inline-block }

  @media screen and (max-width:640px){
      #id_rel .toggleInfo { width:calc(100% - 30px); margin-left: -385px; height:1000px; }
      .txt_info { margin-bottom:30;}
  }
</style>
<style>
  .v--modal-box.v--modal { position: absolute; top:10px !important;}
  .v--modal-box.v--modal:active { top:auto;}
 </style>
